<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.3334 8.33341V12.5001C18.3334 16.6667 16.6667 18.3334 12.5 18.3334H7.50002C3.33335 18.3334 1.66669 16.6667 1.66669 12.5001V7.50008C1.66669 3.33341 3.33335 1.66675 7.50002 1.66675H11.6667"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18.3334 8.33341H15C12.5 8.33341 11.6667 7.50008 11.6667 5.00008V1.66675L18.3334 8.33341Z"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.83331 10.8333H10.8333" :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M5.83331 14.1667H9.16665" :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: 'rgb(var(--locumate-primary-color))',
    },
});
</script>